export default __webpack_public_path__ + "static/All-in-one Toolbar for Easy Editing-5905ed5f94419670c8188276b1a42ce7.jpg";